(()=>{
  if(customElements.get('mk-order-gift'))return;
  const root=window.Shopify?.routes?.root||'/',controls=new Set;
  let state={selected:false,message:''},ready=false,revision=0,savedRevision=0,task=null,timer,status='',pendingNote=null;
  const giftBlock=/(?:\n\n)?Mark Order As Gift: Yes(?:\nGift Message:([\s\S]*))?$/;
  const withoutGift=note=>String(note||'').replace(giftBlock,'').replace(/(?:\n\n)?🎁 GIFT ORDER -[\s\S]*$/,'').trimEnd();
  const withGift=(note,selected,message)=>{
    const base=withoutGift(note);if(!selected)return base;
    return (base?base+'\n\n':'')+'Mark Order As Gift: Yes'+(message.trim()?'\nGift Message: '+message.trim():'');
  };
  const paint=()=>controls.forEach(control=>control.render());
  async function refresh(){
    if(revision!==savedRevision||task)return;
    const version=revision;
    try{const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});if(!response.ok)return;const cart=await response.json();if(version!==revision)return;state={selected:cart.attributes?.['Mark Order As Gift']==='Yes',message:cart.attributes?.['Gift Message']||''};ready=true;paint();}catch{}
  }
  async function persist(){
    clearTimeout(timer);
    if(task)return task;
    if(revision===savedRevision)return true;
    task=(async()=>{
      try{
        while(savedRevision!==revision){
          const version=revision,snapshot={...state},draft=pendingNote;status='saving';paint();
          const latest=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});if(!latest.ok)throw Error('Unable to read cart notes');const current=await latest.json();
          const note=withGift(draft===null?current.note:draft,snapshot.selected,snapshot.message);
          const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({note,attributes:{'Mark Order As Gift':snapshot.selected?'Yes':'','Gift Message':snapshot.selected?snapshot.message.trim():''}})});
          if(!response.ok)throw Error('Gift save failed');await response.json();savedRevision=version;if(version===revision){pendingNote=null;document.querySelectorAll('cart-note textarea').forEach(input=>{if(input!==document.activeElement)input.value=note;});}
        }
        status='';paint();try{localStorage.setItem('mk-order-gift-sync',String(Date.now()));}catch{}return true;
      }catch{status='error';paint();return false;}finally{task=null;}
    })();return task;
  }
  function update(next,immediate=false){state=next;ready=true;revision++;status='';paint();clearTimeout(timer);if(immediate)void persist();else timer=setTimeout(persist,350);}
  customElements.define('mk-order-gift',class extends HTMLElement{
    connectedCallback(){
      controls.add(this);
      if(!ready){state={selected:this.querySelector('[data-gift-toggle]').getAttribute('aria-pressed')==='true',message:this.querySelector('[data-gift-message]').value};ready=true;void refresh();}
      this.onclick=event=>{
        if(event.target.closest('[data-gift-toggle]')){const selected=!state.selected;update({selected,message:selected?state.message:''},true);if(selected)this.querySelector('textarea').focus();}
        if(event.target.closest('[data-gift-retry]'))void persist();
      };
      this.oninput=event=>{if(event.target.matches('[data-gift-message]'))update({...state,message:event.target.value.slice(0,500)});};
      this.onchange=event=>{if(event.target.matches('[data-gift-message]'))void persist();};
      this.render();
    }
    disconnectedCallback(){controls.delete(this);}
    render(){
      const button=this.querySelector('[data-gift-toggle]'),input=this.querySelector('[data-gift-message]');
      button.setAttribute('aria-pressed',String(state.selected));button.setAttribute('aria-expanded',String(state.selected));button.classList.toggle('button--secondary',state.selected);
      this.querySelector('.mk-gift-panel').hidden=!state.selected;
      if(input!==document.activeElement&&input.value!==state.message)input.value=state.message;
      this.querySelector('[data-gift-status]').textContent=status==='saving'?this.dataset.saving:status==='error'?this.dataset.error:'';
      this.querySelector('[data-gift-retry]').hidden=status!=='error';
    }
  });
  if(document.querySelector('cart-note'))void refresh();
  document.addEventListener('input',event=>{
    if(!event.target.matches('cart-note textarea'))return;
    event.stopImmediatePropagation();pendingNote=event.target.value;
    const match=pendingNote.match(giftBlock);
    update({selected:!!match,message:match?(match[1]||'').trim():''});
  },true);
  let bypass=false;
  document.addEventListener('submit',event=>{
    if(bypass||revision===savedRevision)return;
    const form=event.target,submitter=event.submitter;
    if(!submitter?.matches('[name="checkout"]'))return;
    event.preventDefault();event.stopImmediatePropagation();
    void persist().then(ok=>{if(ok){bypass=true;try{form.requestSubmit(submitter);}finally{bypass=false;}}});
  },true);
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]');if(!link||revision===savedRevision)return;
    const url=new URL(link.href,location.href);if(url.origin!==location.origin||!/^\/checkouts?(\/|$)/.test(url.pathname))return;
    event.preventDefault();event.stopImmediatePropagation();void persist().then(ok=>{if(ok)location.assign(link.href);});
  },true);
  window.addEventListener('storage',event=>{if(event.key==='mk-order-gift-sync')void refresh();});
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden'&&revision!==savedRevision)void persist();else if(document.visibilityState==='visible'&&controls.size)void refresh();});
})();

